module.exports = __webpack_public_path__ + "img/emoji-laughing.66b16fa9.svg";